
import { Site } from "@/services/types";

interface SitesMapSectionProps {
  sites: Site[];
  isLoading: boolean;
}

const SitesMapSection = ({ sites, isLoading }: SitesMapSectionProps) => {
  if (isLoading) {
    return (
      <div className="w-full h-[600px] rounded-xl shadow-lg border border-gray-200 bg-gradient-to-br from-gray-50 to-gray-100 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-fabre-green mx-auto mb-4"></div>
          <p className="text-fabre-gray text-lg font-medium">Chargement de la carte interactive...</p>
          <p className="text-fabre-darkteal text-sm mt-2">Localisation de nos sites en cours</p>
        </div>
      </div>
    );
  }

  return (
    <div className="w-full h-[600px] rounded-xl shadow-lg border border-gray-200 mb-8 overflow-hidden">
      <iframe 
        src="https://storage.googleapis.com/maps-solutions-qcoqmdt5th/locator-plus/oo2t/locator-plus.html?hl=fr&gl=FR"
        width="100%" 
        height="100%"
        style={{ border: 0 }}
        loading="lazy"
        title="Carte interactive - Localisation de nos sites Groupe Fabre Environnement"
        allow="geolocation; fullscreen; web-share"
        referrerPolicy="no-referrer-when-downgrade"
        sandbox="allow-scripts allow-same-origin allow-popups allow-forms"
        className="rounded-xl"
      />
    </div>
  );
};

export default SitesMapSection;
